import { objectOf, arrayOf, anyOf, maybe, enumOf } from "@altostra/type-validations";
import { string, number, nullValidation } from "@altostra/type-validations/lib/primitives";

import type { FunnelReportDetails } from "./types";

const nullableString = anyOf(string, nullValidation);
const nullableNumber = anyOf(number, nullValidation);

export const isFunnelReportDetailsResult = objectOf<FunnelReportDetails>({
  id: string,
  name: string,
  company_id: string,
  app_group_id: string,
  steps: arrayOf(
    objectOf({
      event_type: enumOf("session", "purchase", "custom_event", "message_engagement_event"),
      event_value: maybe(nullableString),
    })
  ),
  start_date: nullableNumber,
  end_date: nullableNumber,
  conversion_window: number,
  developer_id: string,
  developer_name: nullableString,
  last_edited_by_id: nullableString,
  last_edited_by_name: nullableString,
  created_at: nullableNumber,
  updated_at: nullableNumber,
  edited_at: nullableNumber,
});
